import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MerchantStoreOnboardingComponent } from 'app/components/merchant/merchant-store-onboarding/merchant-store-onboarding.component';
import {
    ByMerchantRequestDto,
    CreateMerchantPayoutAccountRequestDto,
    PayoutAccountType,
    PayoutAccountTypeEnum,
    WalletDetail
} from 'app/models';
import { AppDataService, MerchantService } from 'app/services';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'merchant-create-payment',
    templateUrl: './merchant-create-payment.component.html',
    styleUrls: ['./merchant-create-payment.component.scss',
        '../../../../../styles/sidebar.scss'],
    providers: [MessageService]
})
export class MerchantCreatePaymentComponent implements OnInit {
    public showMerchantAddPaymentSideBar: boolean = false;
    @Input()
    set _showMerchantAddPaymentSideBar(value: boolean) {
        this.showMerchantAddPaymentSideBar = value;
    }

    public merchantId: number = 0;
    @Input()
    set _merchantId(value: any) {
        this.merchantId = value;
        if (this.merchantId > 0) {
            this.getMerchantPayoutAccount();
        }
    }

    @Input() public merchantStoreOnboardingComponent: MerchantStoreOnboardingComponent | null = null;

    @Output() changedShowMerchantAddPaymentSideBarEmit = new EventEmitter<boolean>();
    changedShowMerchantAddPaymentSideBar(increased: any) {
        this.changedShowMerchantAddPaymentSideBarEmit.emit(increased);
    }

    constructor(private messageService: MessageService,
        private merchantService: MerchantService,
        public appData: AppDataService) { }

    public loading: boolean = false;

    public payment: any = {};
    public payoutAccountTypeEnum = PayoutAccountTypeEnum;
    public payoutAccountTypes = PayoutAccountType.PayoutAccountTypeList;
    public walletDetails = WalletDetail.WalletDetailList;

    ngOnInit(): void { }

    public getMerchantPayoutAccount() {
        this.loading = true;

        const dto: ByMerchantRequestDto = {
            MerchantId: parseInt(this.appData.authData.MerchantId, 10)
        };

        this.merchantService.getMerchantPayoutAccount(dto, this.messageService).then(data => {
            if (!data) {
                this.loading = false;
                return;
            }

            if (!data.Success) {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.payment = data;
            this.loading = false;
        }).catch(err =>{
            this.loading = false;
            throw err;
        });
    }

    public createPayment() {
        const isCheck = this.checkPaymentFields();
        if (isCheck) {
            this.loading = true;
            const dto: CreateMerchantPayoutAccountRequestDto = {
                MerchantId: parseInt(this.appData.authData.MerchantId, 10),
                PayoutAccountTypeId: this.payment.PayoutAccountTypeId,
                WalletDetailId: this.payment.WalletDetailId,
                AccountName: this.payment.AccountName,
                AccountNumber: this.payment.AccountNumber,
                UsePaymayaAccount: false,
                PayServiceId: 0
            };

            if (!dto.MerchantId || !dto.AccountName || !dto.AccountNumber) {
                this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Fill all required fields.' });
                this.loading = false;
                return;
            }

            this.merchantService.createMerchantPayoutAccount(dto, this.messageService).then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.loading = false;
                if (this.merchantStoreOnboardingComponent) {
                    this.merchantStoreOnboardingComponent.getMerchantUserAndMerchant();
                    this.merchantStoreOnboardingComponent.getMerchantPayoutAccounts();
                }
                this.cancel();
            }).catch(err =>{
                this.loading = false;
                throw err;
            });
        }
    }

    private checkPaymentFields() {
        const requiredFields = [
            { field: this.payment.PayoutAccountTypeId, message: 'Payout Account Type is required field' },
            { field: this.payment.AccountName, message: 'Account name is required field' },
            { field: this.payment.AccountNumber, message: 'Account number is required field' }
        ];

        if (this.payment.PayoutAccountTypeId === PayoutAccountTypeEnum.EWallet) {
            requiredFields.push({ field: this.payment.WalletDetailId, message: 'E-Wallet Details is required field' });
        }

        for (const { field, message } of requiredFields) {
            if (!field) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
                return false;
            }
        }

        return true;
    }

    cancel() {
        this.changedShowMerchantAddPaymentSideBar(false);
    }
}
